import type { ParsedLocation } from '@tanstack/react-router';

export const PAGE_SCROLL_RESTORATION_ID = 'page-content';

export const PAGE_SCROLL_RESTORATION_SELECTOR = `[data-scroll-restoration-id="${PAGE_SCROLL_RESTORATION_ID}"]`;

export const getPageScrollRestorationKey = (location: ParsedLocation): string => location.pathname;
